import React from 'react'
import NotFound from '../pages/notfoundPage/NotFound';

function UserPrivateRoute({children}) {
  const user =  localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("loginData"));
  return user && userData ? children : <NotFound/>
}

export default UserPrivateRoute